<template>
  <b-container fluid>
    <b-overlay :show="show" rounded="sm">
      <b-row class="mb-2">
        <b-col md="6" style="fonct-size: 0.875rem">
          <b>Name:</b>
          {{ customerInfo._clientName }}
          <b class="ml-2">Mobile:</b>
          <b-btn
            variant="link"
            @click="initiateCall(0)"
            :disabled="calledNum.includes(customerInfo._mobile)"
            
          >
            {{ customerInfo._mobile }}
            <b-icon icon="telephone-outbound-fill" scale="0.75"></b-icon>
          </b-btn>
        
          <b-btn
            variant="link"
            @click="copyAddress"
            class="ml-2"
          >
            Primary Address
          </b-btn>
        </b-col>
        <b-col>
          <b-button
            variant="info"
            @click="showDel"
            size="small"
            v-if="multiDel"
            class="float-left"
            >View Linked Accounts</b-button
          >
          <b-button
            size="small"
            class="float-right"
            variant="primary"
            to="/calllist"
            >Back</b-button
          >
        </b-col>
      </b-row>
      <b-modal size="xl" ref="modalDel" hide-footer>
        <b-table
          sticky-header="400px"
          small
          style="font-size: 0.75rem"
          :items="delitems"
          striped
          boardered
          head-variant="dark"
        ></b-table>
      </b-modal>
      <b-row>
        <b-col md="4" sm="12" class="mt-2">
          <b-form-group
            class="my-2"
            id="grp1"
            label-cols="3"
            label-size="sm"
            label="Call Response"
          >
            <b-select
              size="sm"
              :options="callCodes"
              text-field="formName"
              value-field="_id"
              v-model="selected"
              @change.native="selectForm"
              :disabled="disableSelect"
            ></b-select>
          </b-form-group>

          <form-generator :schema="schema" v-model="formData"></form-generator>
          <b-alert
            :show="dismissCountDown"
            dismissible
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >{{ alertText }}</b-alert
          >
          <b-button
            variant="secondary"
            class="float-right mt-2 mx-2"
            @click="next"
            size="small"
            v-if="showBtn"
            >Next</b-button
          >
          <b-button
            variant="success"
            class="float-right mt-2"
            @click="submitForm"
            size="small"
            :disabled="disableSelect"
            >Save</b-button
          >
        </b-col>

        <b-col md="8" sm="12">
          <b-tabs content-class="mt-3">
            <b-tab active>
              <template v-slot:title>
                <span style="font-size: 0.875rem">Genral Info</span>
              </template>
              <b-row>
                <b-col>
                  <b-table
                    sticky-header="400px"
                    small
                    style="font-size: 0.75rem"
                    :items="items"
                    striped
                    boardered
                  ></b-table>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span style="font-size: 0.875rem">Call History</span>
              </template>
              <b-table
                small
                style="font-size: 0.75rem"
                show-empty
                :items="callHistory"
                striped
                boardered
              ></b-table>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span style="font-size: 0.875rem">Family Members</span>
              </template>
              <b-table
                small
                style="font-size: 0.75rem"
                show-empty
                :fields="familyfields"
                :items="familymemberlist"
                striped
                boardered
              ></b-table>
              <!-- <b-row  v-for="num in familymemberlist" :key="num">
                <b-col md="3">{{num.name}}</b-col><b-col md="6">{{num.member_mobile_number}} </b-col>
                <b-col md="6">{{num.relation}} </b-col>
              </b-row> -->
              <b-row>
                <!--<b-col md="3">
                  <i>Family Members</i>
                  <p v-for="num in alternateNumbers" :key="num">{{num}}</p>
                  <b-btn
                    v-for="num in alternateNumbers"
                    :key="num"
                    variant="link"
                    @click="initiateCall(num)"
                    :disabled="calledNum.includes(num)"
                  >
                    {{ num }}
                    <b-icon
                      icon="telephone-outbound-fill"
                      scale="0.75"
                    ></b-icon>
                  </b-btn>
                </b-col>
                <b-col md="2">
                  <i>New Numbers</i>
                  <p v-for="num in newNumbers" :key="num">{{num}}</p>
                  
                  <b-btn
                    v-for="num in newNumbers"
                    :key="num"
                    variant="link"
                    @click="calledNum.includes(num)"
                  >
                    {{ num }}
                    <b-icon
                      icon="telephone-outbound-fill"
                      scale="0.75"
                    ></b-icon>
                  </b-btn>
                </b-col>-->
              </b-row>
            </b-tab>
            
            <b-tab>
              <template v-slot:title>
                <span style="font-size: 0.875rem">Location</span>
              </template>
                <GoogleMapDashboard :center1="center1"  />

            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span style="font-size: 0.875rem">Services</span>
              </template>
              <b-table
                small
                style="font-size: 0.75rem"
                show-empty
                :items="services"
                striped
                boardered
              ></b-table>
            </b-tab>
            <b-tab v-for="i in tabsArray" :key="'dyn-tab-' + i">
              <template v-slot:title>
                <span style="font-size: 0.875rem">{{ tabsNames[i] }}</span>
              </template>
              <b-table
                small
                show-empty
                style="font-size: 0.75rem"
                :items="itemsArray[i]"
                striped
                boardered
              ></b-table>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <b-modal ref="mdlAdrs">
        <p>{{customerInfo.primaryAddress}}</p>
      </b-modal>
    </b-overlay>
  </b-container>
</template>

<script>
import FormGenerator from "../components/Generator/FormGenerator";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import apis from "@/apis";
import * as _ from "lodash";
import GoogleMapDashboard from '../components/GoogleMapDashboard'


export default {
  name: "CallerView",
  components: { FormGenerator, DatePicker,GoogleMapDashboard },
  props: ["id", "processname", "sip"],
  data() {
    return {
      show: false,
      disableSelect: true,
      showBtn: false,
      _id: "",
      mobile: "",
      center1:{lng:72.998993,lat:19.077065},
      campaignid: "",
      familymemberlist:[],
      selected: "",
      delitems: [],
      multiDel: false,
      callResponse: "",
      positiveFlag: true,
      callCodes: [], //Forms created in Database will be mapped here the text field is 'formName' and value field is '_id'
      callHistory: [],
      services: [],
      formData: {},
      schema: [],
      customerInfo: {},
      items: [],
      tabsArray: [],
      tabsNames: [],
      itemsArray: [],
      alternateNumbers: [],
      familyfields:[
        "name",
        "member_mobile_number",
        "relation"] ,
      newNumbers: [],
      tabCounter: 0,
      dismissSecs: 5,
      dismissCountDown: 0,
      alertText: "",
      alertVariant: "success",
      isLoading: false,
      payload: {
        process: "",
        filter: {},
        set: {},
        push: {},
        inc: {},
      },
      calledNum: [],
    };
  },
  methods: {
    copyAddress(){
      this.$refs['mdlAdrs'].show();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    initiateCall(num) {
      this.show = true;
      if (num == 0) {
        num = this.customerInfo._mobile;
      }
      this.calledNum.push(num);
      if(this.$store.getters.currentCompany == 'HDFC')
      {
        num = '4'+num;
      } else {
        num = '6'+num;
      }
      
      let promise = apis.initiateCall(this.$store.getters.getSip, num);
      // promise
      //   .then(response => {
      //     if (response.status != 200) {
      //       alert("Error");
      //     } else {
      //       this.disableSelect = false;
      //     }
      //     this.show = false;
      //   })
      //   .catch(err => {
      //     alert("Error: Unable to connect to server");
      //     this.show = false;
      //   });
      promise
        .then((response) => {
          this.disableSelect = false;
          this.show = false;
        })
        .catch((err) => {
          this.disableSelect = false;
          this.show = false;
        });
    },
    selectForm(evt) {
      let id = evt.target.value;

      let form = _.filter(this.callCodes, { _id: id });

      if (form) {
        this.schema = form[0].formDetails;
        this.callResponse = form[0].callCode;
        this.positiveFlag = form[0].positiveFlag;
        //this.process = form[0].process;
      }
    },

    submitForm(evt) {
      let callDetails = "Num:" + this.mobile;
      callDetails += "||response:" + this.callResponse;

      if (
        Object.keys(this.formData).length != Object.keys(this.schema).length
      ) {
        this.alertText = "Please fill all data";
        this.alertVariant = "warning";
        this.dismissCountDown = 4;
        return;
      } else if (this.callResponse == "") {
        this.alertText = "Please select response";
        this.alertVariant = "warning";
        this.dismissCountDown = 4;
        return;
      }

      for (var input in this.formData) {
        //Check if all the data is entered by the user.
        if (this.formData[input] == "" || this.formData[input] == null) {
          this.dismissCountDown = this.dismissSecs;
          this.alertText = "Please fill all the fields";
          return;
        }

        if (this.formData[input].constructor.toString().indexOf("Array") > -1) {
          //if there is multiselection create string -> Need optimization
          callDetails += "||" + input + ":" + _.join(this.formData[input], ",");
        } else {
          callDetails += "||" + input + ":" + this.formData[input];
        }
      }

      this.show = true;
      //Generate Match Criteria for save.
      this.payload.filter = {
        _id: this.customerInfo._id,
        priorityNum: this.campaignid, //in backend make priorityHisotry.priorityNum
      };

      //Generate Set Values for record Update.
      //1. Check PositiveResponse
      let pflg = this.customerInfo.positiveFlag;
      let prspns = this.customerInfo.positiveResponse;
      if (pflg != "Positive") {
        prspns = this.callResponse;
        if (this.positiveFlag) {
          pflg = "Positive";
        } else {
          pflg = "Negative";
        }
      }
      this.payload.set = {
        lastCallResponse: this.callResponse,
        lastCallComment: callDetails,
        lastCallCaller: this.sip,
        lastCallSip: this.sip,
        positiveFlag: pflg,
        positiveResponse: prspns,
        "priorityHisotry.$.priorityPending": false,
        priorityPending: false,
        clientDetails: this.formData,
      };

      //Push Call History
      let callLog = {
        callResponse: this.callResponse,
        callFeedBack: callDetails,
        numberCalled: this.mobile,
        SIP: this.sip,
        positiveFlag: this.positiveFlag,
      };
      this.payload.push = {
        callHistory: callLog,
        clientHistory: this.formData,
      };
      this.payload.inc = { callCount: 1 };

      //console.log(this.payload);

      let promise = apis.saveCall(this.payload);
      promise
        .then((response) => {
          if (response.status == 200) {
            this.show = false;
            this.showBtn = true; //Show Next button.
            this.alertText = "Datasaved Successfully";
            this.dismissCountDown = this.dismissSecs;
            this.alertVariant = "success";
          } else {
            this.show = false;
            this.alertText = "Error while Saving Data";
            this.dismissCountDown = 5;
            this.alertVariant = "warning";
            console.log(response);
          }
        })
        .catch((err) => {
          console.error(err);
          this.show = false;
          this.alertText = "Error in Saving Data:" + err;
          this.alertVariant = "danger";
          this.dismissCountDown = this.dismissSecs;
        });
    },

    showDel() {
      if (this.delitems.length == 0) {
        let promise = apis.getMultiDel(
          this.customerInfo._id,
          this.payload.process
        );

        promise
          .then((response) => {
            if (response.status == 200) {
              this.delitems = response.body;
            }
          })
          .catch((error) => {});
      }
      this.$refs["modalDel"].show();
    },
    next() {
      let indx = parseInt(this.$session.get("index"));
      let list = {};
      if (this.$session.has("filterList")) {
        list = this.$session.get("filterList");
      } else {
        list = this.$session.get("callList");
      }
      let max = list.length - 1;
      if (indx < max) {
        this._id = list[indx + 1]._id;
        this.mobile = "";
        this.selected = "";
        this.delitems = [];
        this.multiDel = false;
        this.callResponse = "";
        this.positiveFlag = true;
        this.callHistory = [];
        this.formData = {};
        this.schema = [];
        this.customerInfo = {};
        this.items = [];
        this.tabsArray = [];
        this.tabsNames = [];
        this.itemsArray = [];
        this.alternateNumbers = [];
        this.newNumbers = [];
        this.tabCounter = 0;
        this.$session.set("index", indx + 1);
        this.disableSelect = true;
        this.showBtn = false;
        this.loadDetails();
        this.calledNum = [];
      }
    },
    getfamilymemberlist()
    {
      this.show = true;
      this.delitems = [];
      var data={
        // user_id:this._id,
        user_id:"63afefd28806f2e333a6e188",
        processName:this.$store.getters.currentProcess
      }
      let promise = apis.familymemberlist(
        data
      );
      promise
        .then((response) => {
          if (response.status == 200) {
            this.familymemberlist=response.data.data;
        }});
    },
    loadDetails() {
      this.show = true;
      this.delitems = [];
      var data={
        id:this._id,
        processName:this.$store.getters.currentProcess
      }
      let promise = apis.getClient(
        data
      );
      promise
        .then((response) => {
          if (response.status == 200) {
            this.familymemberlist=response.data.data;
        }});
    },
    loadDetails() {
      this.show = true;
      this.delitems = [];
      var data={
        id:this._id,
        processName:this.$store.getters.currentProcess
      }
      let promise = apis.getClient(
        data
      );
      promise
        .then((response) => {
          if (response.status == 200) {
            this.showBtn = false;
            this.customerInfo = response.data.data;
            this.callHistory = response.data.data.callHistory;

            if (
              response.data.data._priority != "" &&
              response.data.data._priority.toString() != "0"
            ) {
              //Need to check if priority is pending
              this.campaignid = response.data.data._priority.toString();
            }
            //console.log('schema', JSON.stringify(this.schema));
            for (var i in this.customerInfo) {
              //console.log(typeof this.customerInfo[i]);

              if (i == "multi") {
                if (this.customerInfo[i] > 0) {
                  this.multiDel = true;
                }
                this.items.push({ name: i, value: this.customerInfo[i] });
              } else if (i == "alternateNumbers") {
                this.alternateNumbers = _.sortedUniq(this.customerInfo[i]);
              } else if (i == "newNum") {
                this.newNumbers = _.sortedUniq(this.customerInfo[i]);
              } else if (
                i != "clientHistory" &&
                i != "callHistory" &&
                i != "linkedRecords" &&
                i.substring(0, 1) != "_"
              ) {
                if (
                  typeof this.customerInfo[i] === "object" &&
                  this.customerInfo[i] != null
                ) {
                  if (
                    this.customerInfo[i].constructor
                      .toString()
                      .indexOf("Object") > -1
                  ) {
                    this.items.push({
                      name: i,
                      value: this.customerInfo[i]["$numberDecimal"],
                    });
                  } else if (
                    this.customerInfo[i].constructor
                      .toString()
                      .indexOf("Date") > -1
                  ) {
                    this.items.push({ name: i, value: this.customerInfo[i] });
                  } else if (
                    this.customerInfo[i].constructor
                      .toString()
                      .indexOf("Array") > -1 &&
                    i != ""
                  ) {
                    this.tabsArray.push(this.tabCounter++);
                    this.tabsNames.push(i);
                    this.itemsArray.push(this.customerInfo[i]);
                  }
                } else {
                  this.items.push({ name: i, value: this.customerInfo[i] });
                }
              }
            }
          }
          this.show = false;
        })
        .catch((err) => {
          this.show = false;
          this.alertText = "Error is GEtting Data:" + err;
          this.alertVariant = "danger";
          this.dismissSecs = 5;
        });
    },
  },
  mounted() {
    this._id = this.id;
    this.calledNum = [];
    this.callCodes = this.$store.getters.getForm;
    this.payload.process = this.$store.getters.currentProcess;
    this.loadDetails();
    this.getfamilymemberlist();
  },
};
</script>